import { useFormContext, useFormField } from '@calendly/form'

import { useGetUserQuery } from 'common'
import { DateSpecificRules } from 'components/availability/form/date_specific_rules'
import { useEventType } from 'features/event_type_provider'
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction'


export const DateSpecificHours = ({ formPath, readOnly }) => {
  const eventType = useEventType()
  const [{ value: { availableHours, timezone, dateOverrides } }] = useFormField({ name: formPath })
  const { setFieldValue } = useFormContext()

  const setUsingCustomHours = () => {
    setFieldValue(`${formPath}.usingCustomHours`, true)
    setFieldValue(`${formPath}.usingSecondarySchedule`, false)
  }
  const { data: currentUser } = useGetUserQuery()

  const setDateOverrides = (dates) => {
    setUsingCustomHours()

    setFieldValue(`${formPath}.dateOverrides`, dates)
  }

  const trackOpen = useTrackAvailabilityInteraction({
    eventType,
    location: 'et_editor',
    action: 'view_date_specific_hours'
  })

  return (
    <DateSpecificRules
      readOnly={readOnly}
      days={availableHours}
      dates={dateOverrides}
      setDates={setDateOverrides}
      timezone={timezone || currentUser.timezone}
      trackOpen={trackOpen}
      redesignStyling
      compact
    />
  )
}
